import { FolderGit2 } from 'lucide-react';
import type { ModuleMeta } from '../types';

export const meta: ModuleMeta = {
  id: 'projects',
  label: 'Projects',
  route: '/projects',
  icon: FolderGit2,
};
